import React from 'react';
import './homepage.css'
import NavBar from './components/Navbar/Navbar';
import HeroSection from './components/HeroSection/HeroPage';
import BrandMarquee from './UIComponent/marqueeAnimation';
import ProductSection from './components/ProductSection/Product';
import LendingPartners from './components/LendingPartnerSection/LendingPartner';
import RangeSliderExample from './UIComponent/rangeSlider';
import EmiCalculator from './components/EmiCalculator/EmiCalculator';
import DocumentsAndEligibility from './components/DocumnetRequired/DocumentRequired';
import Testimonials from './components/Testimonials/Testimonial';
import Faqs from './components/FaqSection/faq';
import PrivacySection from './components/privacySection/Privacy';
import FooterSection from './components/footer/footer';
import SEO from '../../SEO/SEO';
import ROUTES from '../../constants/RouteData';

const HomePage = () => {
  return (
    <>
      <SEO
        title="DigitMoney – Personal Loan Simplified"
        description="DigitMoney is your trusted personal loan partner offering instant approvals, paperless processing, and quick disbursements. Get loans up to ₹5,00,000 with low interest rates and a fully digital journey. Trusted by thousands for fast, secure, and easy lending."
        keywords="DigitMoney, Instant Personal Loan, Online Loan India, Digital Loan, Paperless Loan, Low Interest Loan, Fast Loan Approval, Instant Loan App, EMI Loan, Quick Disbursal"
        image="https://digitmoney.in/assets/img/DMIcon.png"
        url={`https://digitmoney.in/${ROUTES.home}`}
      />

      <div className="min-h-screen w-full flex flex-col overflow-x-hidden relative font-sans">
        {/* === Fullscreen Background Video === */}
        <div className="relative min-h-[100vh] w-full flex flex-col bg-gradient-to-b from-emerald-950 via-black to-black items-center justify-start overflow-hidden z-0">

          <video


            className="
          custom-video
        
         absolute top-0 left-0 w-full h-[65%] 
         sm:h-full
         sm:scale-[1.3] 
         rotate-0 sm:rotate-180
         brightness-[0.2] sm:brightness-[0.7] 
         -z-10
       "
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/assets/video/BG video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>


          {/* Nav & Hero */}
          <NavBar />
          <HeroSection />
          <BrandMarquee />

          {/* Blur Background Text (now positioned in % for responsiveness) */}
          <h1
            style={{ fontFamily: 'myFirstFont' }}
            className="absolute text-[35px] top-[275px] left-[-160px] blur-[2px] sm:top-[150px] sm:left-[-60px]  text-[#12F28040] sm:text-[80px] sm:blur-sm whitespace-nowrap"
          >
            Personal Loan
          </h1>
          <h1
            style={{ fontFamily: 'myFirstFont' }}
            className="absolute text-[35px] top-[275px] right-[-160px] sm:top-[150px]  sm:right-[-30px] blur-[2px] text-[#12F28040] sm:text-[80px] sm:blur-sm whitespace-nowrap"
          >
            Debt Consoli
          </h1>

          <div className='hidden sm:block w-full h-[1px] bg-gray-800 mt-10 mb-[30px]' />

          <ProductSection />
        </div>



        {/* === Hero Section 2 === */}
        <LendingPartners />

        <EmiCalculator />

        <DocumentsAndEligibility />

        {/* === Footer === */}
        <Testimonials />
        <Faqs />



        <div className="relative w-full flex flex-col overflow-hidden z-0">
          {/* Background Video */}
          <video
            className="
      custom-video
      hidden sm:block
      absolute top-0 left-0 w-full h-full
      sm:scale-[1.1]
      brightness-[0.2] sm:brightness-[0.4]
      object-cover
      z-[-1]
    "
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/assets/video/BG video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Main Content */}
          <main className="flex-grow ">
            <PrivacySection />
          </main>

          {/* Footer - will naturally stay at the bottom or push page height */}
          <FooterSection />

        </div>



      </div>
    </>
  );
};

export default HomePage;
